import React from 'react';
import useWeb3 from '../../../contexts/web3';
import useUserData from '../../../contexts/userData';
import Button from '../../controls/button';

interface Props {
  inverted?: boolean;
  className?: string;
}

const LoginButton = ({ inverted, className }: Props) => {
  const { handleMetamaskClick } = useWeb3();
  const { login, loginLoading } = useUserData();

  const handleClick = () => handleMetamaskClick(login, 'login/signup');

  return (
    <Button
      variant='contained'
      color={inverted ? 'black' : 'primary'}
      onClick={handleClick}
      loading={loginLoading}
      className={className}
    >
      Connect Wallet
    </Button>
  );
};

export default LoginButton;
